import { useMemo, useState } from "react";
import { View } from "react-native";
import AnimatedBackgroundColorView from "src/components/AnimatedBackgroundColorView";
import PillButton from "src/components/PillButton";
import useStabilizedCallback from "src/hooks/useStabilizedCallback";
import IconClose from "src/icons/IconClose";
import { paddingMedium, paddingXL } from "src/styles/spacing";
import { Text, useSafeArea } from "src/swsh-native";
import RecapScreenContentContainer from "./components/RecapScreenContentContainer";
import { RECAP_ANIMATION_DURATION } from "./constants";
import { RecapContentProps } from "./types";

const RecapContent = ({ recap, style, onClose }: RecapContentProps) => {
	const [prevIndex, setPrevIndex] = useState<number | null>(null);
	const [index, setIndex] = useState(0);
	const curScreen = useMemo(() => {
		return recap.screens?.[index];
	}, [recap, index]);

	const handleSetIndex = useStabilizedCallback(
		(newIndex: number) => {
			const parsedNewIndex = Math.min(
				Math.max(newIndex, 0),
				(recap.screens?.length ?? 0) - 1,
			);
			setPrevIndex(index);
			setIndex(parsedNewIndex);
		},
		[index, recap.screens?.length],
	);
	const safeArea = useSafeArea();

	return (
		<AnimatedBackgroundColorView
			backgroundColor={curScreen?.backgroundColor ?? undefined}
			style={[
				style,
				{
					paddingTop: paddingXL + safeArea.top,
					paddingBottom: paddingXL + safeArea.bottom,
					alignItems: "center",
					rowGap: paddingMedium,
				},
			]}
			duration={RECAP_ANIMATION_DURATION}
		>
			<View
				style={{
					flexDirection: "row",
					width: "100%",
					justifyContent: "space-between",
					alignItems: "center",
					paddingHorizontal: paddingXL,
				}}
			>
				<Text semibold>{recap.title}</Text>
				<PillButton onPress={onClose} Icon={IconClose} sizeVariant="sm" />
			</View>
			<RecapScreenContentContainer
				curScreen={curScreen}
				prevIndex={prevIndex}
				index={index}
				numTotalScreens={recap.screens?.length ?? 0}
				onSelect={handleSetIndex}
			/>
		</AnimatedBackgroundColorView>
	);
};
export default RecapContent;
